import { Article } from "components";
import { wgybLeft, wgybRight } from "assets/images";

const WGYB = () => {
  return (
    <Article
      header="WE'VE GOT YOUR BACK"
      content={[
        {
          title: "UNRIVALED DEALER SUPPORT",
          body: "When you invest in a piece of our equipment, we're 100% committed to keeping it up and running along with your operation. That's why your dealer has the equipment and trained techs to service your fleet at a moment‘s notice.",
          src: wgybLeft,
          width: 603,
          height: 339,
          action: {
            title: "Find Your Dealer",
            href: "https://dealerlocator.deere.com/servlet/country=US?locale=en_US",
          },
        },
        {
          title: "FINANCING",
          body: "You need a finance team that does more than just look up your credit score. John Deere Financial Services gets in the trenches to learn about your entire operation and help keep you running strong.",
          src: wgybRight,
          width: 603,
          height: 339,
          action: {
            title: "Learn More",
            href: "https://www.deere.com/en/finance/financing/construction/heavy-construction-equipment/",
          },
        },
      ]}
      bg="dark"
      wgyb
    />
  );
};

export default WGYB;
